import { create } from 'zustand';

/**
 * Tiny shared store for "is the guided tour currently open?"
 *
 * Layout owns the GuidedTour mount, but other components (specifically
 * IntelligenceGate) need to know whether the tour is driving the
 * experience so they can suppress their OWN modal overlays — having the
 * gate's "You're previewing on demo data" acknowledgement modal AND the
 * tour tooltip on top of each other at the same time is exactly what
 * the user flagged 2026-05-24 ("combines several pop up menus that
 * should not belong").
 *
 * Could be plumbed via context or props but a Zustand store is the
 * pattern already used for auth/filter state — keeping consistency.
 */
interface TourState {
  isGuidedOpen: boolean;
  setGuidedOpen: (open: boolean) => void;
}

export const useTourStore = create<TourState>(set => ({
  isGuidedOpen: false,
  setGuidedOpen: (open) => set({ isGuidedOpen: open }),
}));
